import * as React from "react";
import { useInterpolatedString } from "./toucan/src/interpolate";
import { useTranslation } from "react-i18next";
import { playCustomSample } from "./sound";

import { Text, Stack } from "@smartphoneorchestra/components";
import { Screen, TruthAnalyticsLogo } from "./Styles/StyleComponents";

interface CustomSoundTextProps {
  text: string;
  sample: string;
  vol: number;
}

const CustomSoundText = (props: CustomSoundTextProps) => {
  const { t } = useTranslation("thecircleoftruth");
  const transText = t(props.text);
  const text = useInterpolatedString(transText);
  const sample = props.sample;
  const volume = props.vol;

  React.useEffect(() => {
    playCustomSample(sample, volume);
  }, [text, sample]);

  return (
    <Screen align="center" color="blue">
      <TruthAnalyticsLogo width="50%" />
      <Stack grow justify="center">
        <Text center color="primary" size="5">
          {text}
        </Text>
      </Stack>
    </Screen>
  );
};

export default CustomSoundText;
